import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Companies from './components/companies/Companies';
import Questions from './components/questions/Questions';
import Profiles from './components/profiles/Profiles';
import Home from './components/home/Home';
import Levels from './components/levels/Levels';
import CompanyDetails from './components/companies/CompanyDetails';
import NewCompany from './components/companies/NewCompany';
import EditCompany from './components/companies/EditCompany';
import NewQuestion from './components/questions/NewQuestion';
import EditQuestion from './components/questions/EditQuestion';
import NewLevel from './components/levels/NewLevel';
import SignIn from './components/auth/SignIn';
import Terms from './components/plain/Terms';
import Privacy from './components/plain/Privacy';
import PlacesSearch from './components/places/PlacesSearch';
import NewPlaceSearch from './components/places/NewPlaceSearch';
import PlaceSearchDetails from './components/places/PlaceSearchDetails';
import Databases from './components/databases/Databases';
import NewDatabase from './components/databases/NewDatabase';
import NewLevels from './components/levels/NewLevels';
import LevelsConfig from './components/levels/LevelsConfig';
//TODO: keep up with newer react-scripts versions to fix vulnerabilities
//TODO: find alternative library to materialize-css to fix vulnerabilties
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min.js';

import InviteCodes from './components/codes/InviteCodes';
import NewInviteCode from './components/codes/NewInviteCode';
import CallFunctions from './components/callFunctions/CallFunctions';
import Pyns from './components/pyns/Pyns';
import PynsPeaceHill from './components/pyns/PynsPeaceHill';
import Migrations from './components/migrations/Migrations';
import Badges from './components/badges/Badges';
import NewBadge from './components/badges/NewBadge';
import ContestsMenu from './components/contests/ContestsMenu';
import ContestTestData from './components/contests/ContestTestData';
import AllContest from './components/contests/AllContest';
import SafetyZonesPeaceHill from './components/pyns/SafetyZonesPeaceHill';
import ImportTrypStops from './components/pyns/ImportTrypStops';
import RemovePlaceSearchByCompany from './components/places/RemovePlaceSearchByCompany';
import ImportsPynsByCompany from './components/pyns/ImportsPynsByCompany';
import RemovePynsImportedCompany from './components/pyns/RemovePynsImportedCompany';
import RemovePynsByCompany from './components/pyns/RemovePynsByCompany';
import WinnersContest from './components/contests/WinnersContest';
import NewContest from './components/contests/NewContest';
import WeeklyMissionsMenu from './components/weeklyMissions/WeeklyMissionsMenu';
import WeeklyMissions from './components/weeklyMissions/WeeklyMissions';
import NewWeeklyMission from './components/weeklyMissions/NewWeeklyMission';
import VerifyUserMission from './components/weeklyMissions/VerifyUserMission';
import RunContests from './components/contests/RunContests';
import Notifications from './components/notifications/Notifications';
import Profile from './components/profiles/Profile';
import TriviaEntries from './components/contests/TriviaEntries';
import DownloadEntries from './components/contests/DownloadEntries';
import DownloadProfiles from './components/profiles/DownloadProfiles';
import AdminQuestions from './components/questions/AdminQuestions';
import ResetQuestions from './components/questions/ResetQuestions';
import UploadQuestions from './components/questions/UploadQuestions';
import AssignQuestions from './components/questions/AssignQuestions';
import EnableTrivia from './components/questions/EnableTrivia';
import RemoveQuestions from './components/questions/RemoveQuestions';
import Activities from './components/activities/Activities';
import MigratePyns from './components/migrations/MigratePyns';
import ImportPrizes from './components/prizes/ImportPrizes';
import Prizes from './components/prizes/Prizes';
import PrizesMenu from './components/prizes/PrizesMenu';
import PrizesConfig from './components/prizes/PrizesConfig';
import ExportSnapshots from './components/profileTemporarySnapshots/ExportSnapshots';
import UserInbox from './components/userInbox/UserInbox';
import MessageTemplates from './components/messageTemplates/MessageTemplates';
import MessageStatistics from './components/messageTemplates/MessageStatistics';
import MessageStatistic from './components/messageTemplates/MessageStatistic';
import WaitListConfig from './components/waitListConfig/WaitListConfig';
import IncompleteProfiles from './components/profiles/IncompleteProfiles';
import InvalidateEntries from './components/contests/InvalidateEntries';
import ProfileSignupDailyReport from './components/profileSignupDailyReport/ProfileSignupDailyReport';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Switch>
            <Route path="/mobileTerms" render={() => <Navbar mobile={true} />} />
            <Route path="/mobilePrivacy" render={() => <Navbar mobile={true} />} />
            <Route component={Navbar} />
          </Switch>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/signin" component={SignIn} />

            <Route path="/profiles" component={Profiles} />
            <Route path="/profile/:id" component={Profile} />
            <Route path="/incompleteProfiles" component={IncompleteProfiles} />
            <Route path="/downloadProfiles" component={DownloadProfiles} />
            <Route path="/signupDailyReport" component={ProfileSignupDailyReport} />

            <Route path="/companies" component={Companies} />
            <Route path="/newCompany" component={NewCompany} />
            <Route path="/company/:id" component={CompanyDetails} />
            <Route path="/editCompany/:id" component={EditCompany} />

            <Route path="/questions" component={Questions} />
            <Route path="/editQuestion/:id" component={EditQuestion} />
            <Route path="/newQuestion" component={NewQuestion} />
            <Route path="/adminQuestions" component={AdminQuestions} />
            <Route path="/resetQuestions" component={ResetQuestions} />
            <Route path="/uploadQuestions" component={UploadQuestions} />
            <Route path="/removeQuestions" component={RemoveQuestions} />
            <Route path="/assignQuestions" component={AssignQuestions} />
            <Route path="/enableTrivia" component={EnableTrivia} />

            <Route path="/levels" component={Levels} />
            <Route path="/newLevels" component={NewLevels} />
            <Route path="/level/:id" component={NewLevel} />
            <Route path="/level/" component={NewLevel} />
            <Route path="/levelsConfig/" component={LevelsConfig} />

            <Route path="/places" component={PlacesSearch} />
            <Route path="/newPlaceSearch" component={NewPlaceSearch} />

            <Route path="/codes" component={InviteCodes} />
            <Route path="/newInviteCode" component={NewInviteCode} />
            <Route path="/place/:id" component={PlaceSearchDetails} />

            <Route path="/databases" component={Databases} />
            <Route path="/newDatabase" component={NewDatabase} />
            <Route path="/functions" component={CallFunctions} />
            <Route path="/pyns" component={Pyns} />
            <Route path="/pynsPeaceHill" component={PynsPeaceHill} />
            <Route path="/safetyPeaceHill" component={SafetyZonesPeaceHill} />
            <Route path="/importTrypStops" component={ImportTrypStops} />
            <Route path="/migrations" component={Migrations} />

            <Route path="/badges" component={Badges} />
            <Route path="/newBadge" component={NewBadge} />

            <Route path="/contestMenu" component={ContestsMenu} />
            <Route path="/contestTestData" component={ContestTestData} />
            <Route path="/triviaEntries" component={TriviaEntries} />
            <Route path="/downloadEntries" component={DownloadEntries} />
            <Route path="/allContest" component={AllContest} />
            <Route path="/winnersContest" component={WinnersContest} />
            <Route path="/runContests" component={RunContests} />

            <Route path="/removePlaceSearchCompany" component={RemovePlaceSearchByCompany} />
            <Route path="/removePynsImportedCompany" component={RemovePynsImportedCompany} />
            <Route path="/importPynsByCompany" component={ImportsPynsByCompany} />
            <Route path="/removePynsByCompany" component={RemovePynsByCompany} />
            <Route path="/newContest" component={NewContest} />

            <Route path="/weeklyMissionsMenu" component={WeeklyMissionsMenu} />
            <Route path="/weeklyMissions" component={WeeklyMissions} />
            <Route path="/newMission" component={NewWeeklyMission} />
            <Route path="/verifyUserMission" component={VerifyUserMission} />
            <Route path="/notifications" component={Notifications} />

            <Route path="/activities" component={Activities} />
            <Route path="/migratePyns" component={MigratePyns} />
            <Route path="/invalidateEntries" component={InvalidateEntries} />

            <Route path="/prizesMenu" component={PrizesMenu} />
            <Route path="/prizes" component={Prizes} />
            <Route path="/prizesConfig" component={PrizesConfig} />
            <Route path="/importPrizes" component={ImportPrizes} />

            <Route path="/exportSnapshots" component={ExportSnapshots} />
            <Route path="/userInbox" component={UserInbox} />
            <Route path="/messageTemplates" component={MessageTemplates} />
            <Route path="/messageStatistics" component={MessageStatistics} />
            <Route path="/messageStatistic/:id" component={MessageStatistic} />

            <Route path="/waitListConfig" component={WaitListConfig} />
          </Switch>
        </div>
        <div className="Plain">
          <Switch>
            <Route path={['/terms', '/mobileTerms']} component={Terms} />
            <Route path={['/privacy', '/mobilePrivacy']} component={Privacy} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
